import apiStores from '@/api/stores'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  isLoading: false,
  list: [],
  validationErrors: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getStoresListStart: '[sports list] get Stores Start',
  getStoresListSuccess: '[sports list ] get Stores Success',
  getStoresListFailure: '[sports list ] get Stores Failure',
}

export const actionType = {
  getStoreList: '[sports list] get Stores',
}

const mutations = {
  [mutationTypes.getStoresListStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getStoresListSuccess](state, payload) {
    if (payload.isAdd) {
      state.list = [...state.list, ...payload.list]
    } else {
      state.list = payload.list
    }
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getStoresListFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getStoreList](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getStoresListStart)
    return new Promise((resolve) => {
      apiStores
        .getStoresList(params)
        .then((response) => {
          context.commit(mutationTypes.getStoresListSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getStoresListFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
